import React, { useState, useEffect, useCallback } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import { jwtDecode } from "jwt-decode";
import { Modal, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useLoading } from "../../context/LoadingContext";
import config from "../../aws-exports";
import "../../styles/general.css";
import "../../styles/agropreneur.css";
import {
  fetchData,
  postQuery,
  searchfetchQueries,
} from "../../services/BackendServices";

//category addition work

const AgroPreneurDashboard = () => {
  const [queryDescription, setQueryDescription] = useState("");
  const [activeTab, setActiveTab] = useState("basicInfo");
  const [activeUser, setActiveUser] = useState("");
  const [agropreneurItemDetails, setAgropreneurItemDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedAgropreneurItemDetail, setSelectedAgropreneurItemDetail] =
    useState(null);
  const [queries, setQueries] = useState([]);
  const [queryPage, setQueryPage] = useState(1);
  const [queryTotalPages, setQueryTotalPages] = useState(1);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [showRaiseQueryModal, setShowRaiseQueryModal] = useState(false);
  const [farmers, setFarmers] = useState([]);
  const [allFarmers, setAllFarmers] = useState([]);
  const [products, setProducts] = useState([]);
  const [productCategoryMaster, setProductCategoryMaster] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [states, setStates] = useState([]);
  const [filterTerms, setFilterTerms] = useState({
    farmer: "",
    product: "",
    grade: "",
    state: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [isAdding, setIsAdding] = useState(false);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [allProductMaster, setAllProductMaster] = useState([]);
  const navigate = useNavigate();
  const pageSize = 10;
  const queryPageSize = 5;
  const { setLoading } = useLoading();

  const getBackendName = () => {
    const backend = config.aws_user_files_s3_bucket.split("-");
    return backend[backend.length - 1];
  };

  const fetchQueries = async () => {
    if (!selectedAgropreneurItemDetail) {
      console.error("No client selected");
      return;
    }
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "listAmtplQueries",
        access_token: user.signInUserSession.idToken.jwtToken,
        filterTerms: { APItemID: selectedAgropreneurItemDetail?.APItemID },
        rowStart: (queryPage - 1) * queryPageSize,
        pageSize: queryPageSize,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setQueries(result.items);
        setQueryTotalPages(Math.ceil(result.total / queryPageSize));
        if (result.items.length > 0) {
          setSelectedQuery(result.items[0]);
        }
      } else {
        console.error("Error fetching queries: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateQuery = async () => {
    if (!queryDescription) {
      console.error("Query Description is required");
      return;
    }

    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "createAmtplQuery",
        access_token: user.signInUserSession.idToken.jwtToken,
        createAmtplQueryInput: {
          QueryDescription: queryDescription,
          APEmailID: user.attributes.email,
          APItemID: selectedAgropreneurItemDetail?.APItemID,
          QueryType: "AgroPreneur",
        },
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        console.log("Query creation successful", result);
        setShowModalMsg("Query creation successful");
        setShowModal(true);
        // Fetch the updated queries
        fetchQueries();
      } else {
        console.error("Error creating query: ", result);
        setShowModalMsg("Error creating query");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
      setShowModalMsg("Error creating query");
      setShowModal(true);
    } finally {
      setLoading(false);
      setShowRaiseQueryModal(false); // Close the modal after handling the query creation
      setQueryDescription(""); // Clear the query description
    }
  };

  const fetchFarmersForSearch = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listDynamicDropDownOptions",
            option: "farmers",
            access_token: token,
            rowStart: 0,
            pageSize: 100,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setFarmers(result.items.map((option) => option.result));
      } else {
        console.error(`Error fetching farmers : ${JSON.stringify(result)}`);
      }
    } catch (error) {
      console.error(`Error fetching farmers : ${JSON.stringify(error)}`);
    } finally {
      setLoading(false);
    }
  };

  const loadAllProducts = useCallback(async () => {
    setLoading(true);
    try {
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listProducts",
          userOrder: "ProductID",
          rowStart: 0,
          pageSize: 1,
        }),
      ]);
      const totalCount = initialResponse?.total || initialResponse?.length || 0;
      if (totalCount > 0) {
        const [allProducts] = await Promise.all([
          searchfetchQueries({
            target: "listProducts",
            userOrder: "ProductID",
            rowStart: 0,
            pageSize: totalCount,
          }),
        ]);
        setAllProductMaster(allProducts);
      } else {
        setAllProductMaster([]);
      }
    } catch (error) {
      console.error("Error loading products: ", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const loadProductCategories = useCallback(async () => {
    setLoading(true);
    try {
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listProductCategory",
          userOrder: "CategoryName",
          rowStart: 0,
          pageSize: 1,
        }),
      ]);
      const totalCount = initialResponse?.total || initialResponse?.length || 0;
      if (totalCount > 0) {
        const [allProductCats] = await Promise.all([
          searchfetchQueries({
            target: "listProductCategory",
            userOrder: "CategoryName",
            rowStart: 0,
            pageSize: totalCount,
          }),
        ]);
        setProductCategoryMaster(allProductCats);
      } else {
        setProductCategoryMaster([]);
      }
    } catch (error) {
      console.error("Error loading product categories: ", error);
      setProductCategoryMaster([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const loadProducts = useCallback(
    async (productCategoryId) => {
      setLoading(true);
      try {
        const [initialResponse] = await Promise.all([
          fetchData({
            target: "listProducts",
            userOrder: "ProductName",
            rowStart: 0,
            pageSize: 1,
            filterTerms: productCategoryId
              ? { ProductCategoryID: productCategoryId }
              : {},
          }),
        ]);
        const totalCount =
          initialResponse?.total || initialResponse?.length || 0;
        if (totalCount > 0) {
          const [allProducts] = await Promise.all([
            searchfetchQueries({
              target: "listProducts",
              userOrder: "ProductName",
              rowStart: 0,
              pageSize: totalCount,
              filterTerms: productCategoryId
                ? { ProductCategoryID: productCategoryId }
                : {},
            }),
          ]);
          setProducts(allProducts);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error("Error loading products:", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const loadProductGrades = useCallback(
    async (productName) => {
      setLoading(true);
      try {
        const [allGrades] = await Promise.all([
          fetchData({
            target: "listProducts",
            userOrder: "ProductName",
            rowStart: 0,
            pageSize: 500,
            filterTerms: { ProductName: productName, Status: "ACTIVE" },
          }),
        ]);
        if (allGrades.items.length > 0) {
          setProductGradeList(allGrades.items);
        } else {
          setProductGradeList([]);
        }
      } catch (error) {
        console.error("Error loading product grades: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const fetchAllFarmersForSearch = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listDynamicDropDownOptions",
            option: "allfarmers",
            access_token: token,
            rowStart: 0,
            pageSize: 100,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setAllFarmers(result.items.map((option) => option.result));
      } else {
        console.error(`Error fetching farmers : ${JSON.stringify(result)}`);
      }
    } catch (error) {
      console.error(`Error fetching farmers : ${JSON.stringify(error)}`);
    } finally {
      setLoading(false);
    }
  };

  // const fetchProducts = async () => {
  //   setLoading(true);
  //   try {
  //     const credentials = await Auth.currentCredentials();
  //     const lambdaClient = new LambdaClient({
  //       credentials: Auth.essentialCredentials(credentials),
  //       region: config.aws_project_region,
  //     });

  //     const user = await Auth.currentAuthenticatedUser();
  //     const token = user.signInUserSession.idToken.jwtToken;
  //     const backendName = getBackendName();

  //     const command = new InvokeCommand({
  //       FunctionName: `dataops-${backendName}`,
  //       Payload: JSON.stringify({
  //         body: {
  //           target: "listProducts",
  //           access_token: token,
  //           rowStart: 0,
  //           pageSize: 100,
  //         },
  //       }),
  //     });

  //     const data = await lambdaClient.send(command);
  //     let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
  //     if (result.statusCode === 200) {
  //       result = JSON.parse(result.body);
  //       setProducts(result.items);
  //     } else {
  //       console.error("Error fetching products: ", result);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching products", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchPaymentOptions = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listDropDownOptions",
            filterTerms: {
              Type: "PaymentMode",
              Subtype: "India",
            },
            access_token: token,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setPaymentOptions(result.items);
      } else {
        console.error("Error fetching Payment Options: ", result);
      }
    } catch (error) {
      console.error("Error fetching Payment Options", error);
    } finally {
      setLoading(false);
    }
  };

  function formatData(data) {
    return data?.toLocaleString();
  }

  const fetchStates = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listDynamicDropDownOptions",
            option: "agropreneuritemstates",
            access_token: token,
            rowStart: 0,
            pageSize: 100,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setStates(result.items.map((option) => option.result));
      } else {
        console.error(`Error fetching $States : ${JSON.stringify(result)}`);
      }
    } catch (error) {
      console.error(`Error fetching States: ${JSON.stringify(error)}`);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllStates = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listDropDownOptions",
            filterTerms: {
              Type: "State",
              Subtype: "India",
            },
            access_token: token,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setAllStates(result.items);
      } else {
        console.error("Error fetching All States: ", result);
      }
    } catch (error) {
      console.error("Error fetching All States", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAgropreneurItems = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true,
      });

      const body = {
        target: "listAPItemDetails",
        access_token: user.signInUserSession.idToken.jwtToken,
        filterTerms,
        userOrder: "FarmerName",
        rowStart: (currentPage - 1) * pageSize,
        pageSize: pageSize,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setAgropreneurItemDetails(result.items);
        setTotalPages(Math.ceil(result.total / pageSize));
        if (result.items.length > 0) {
          const product = allProductMaster.find(
            (p) => p.ProductID === result.items[0].ProductID
          );
          console.log("@@product", product);
          const pcID = product.ProductCategoryID || "";
          result.items[0].ProductCategoryID = pcID;
          if (pcID) {
            loadProducts(pcID);
          }
          setSelectedAgropreneurItemDetail(result.items[0]);
        }
      } else {
        console.error("Error fetching agropreneurItemDetails: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        // Check if the user is a member of the AMTPL_AGROPRENEURS group
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_AGROPRENEURS")) {
          await Auth.signOut(); // Sign out the user
          navigate("/login/agropreneur");
        } else {
          setActiveUser(user.attributes.email); // Set the active user email
        }
      } catch (error) {
        await Auth.signOut(); // Sign out the user
        navigate("/login/agropreneur");
      }
    };

    checkUser();
    fetchAgropreneurItems();
    // fetchProducts();
    loadAllProducts();
    loadProductCategories();
    fetchStates();
    fetchPaymentOptions();
    fetchAllStates();
    fetchFarmersForSearch();
    fetchAllFarmersForSearch();
  }, [navigate, currentPage, setLoading, filterTerms]);

  useEffect(() => {
    if (activeTab === "queries") {
      fetchQueries();
    }
  }, [selectedAgropreneurItemDetail]);

  const handleSignOut = async () => {
    setLoading(true);
    try {
      await Auth.signOut();
      navigate("/login/agropreneur");
    } catch (error) {
      console.error("Error signing out: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTabClick = (tab) => {
    if (tab === "queries") {
      if (isAdding === true) return;
      fetchQueries();
    }
    setActiveTab(tab);
  };

  const handleQueryPageChange = (newPage) => {
    if (newPage > 0 && newPage <= queryTotalPages) {
      setQueryPage(newPage);
    }
  };

  const handleQueryRowClick = (query) => {
    setSelectedQuery(query);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleRowClick = (agropreneurItemDetail) => {
    // console.log('agropreneurItemDetail###',agropreneurItemDetail);
    const product = allProductMaster.find(
      (p) => p.ProductID === agropreneurItemDetail.ProductID
    );
    console.log("@@product", product);
    const pcID = product.ProductCategoryID || "";
    agropreneurItemDetail.ProductCategoryID = pcID;
    if (pcID) {
      loadProducts(pcID);
    }
    // console.log('agropreneurItemDetail@@',agropreneurItemDetail);
    setSelectedAgropreneurItemDetail(agropreneurItemDetail);
  };

  const handleCategoryChange = useCallback(
    (e) => {
      handleFilterChange(e);
      loadProducts(e.target.value);
    },
    [loadProducts]
  );

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterTerms((prevTerms) => ({ ...prevTerms, [name]: value }));
    resetFilter();
  };

  const handleSearch = () => {
    resetFilter();
  };

  const handleReset = () => {
    setFilterTerms({ product: "", grade: "" });
    resetFilter();
  };

  const handleSave = async () => {
    let status = "Save";
    if (isAdding) status = "Add";
    if (!selectedAgropreneurItemDetail) {
      console.error("No client selected");
      return;
    }

    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      console.log(
        "selectedAgropreneurItemDetail@@",
        selectedAgropreneurItemDetail
      );
      const {
        HarvestDate,
        Status,
        SellerItemID,
        APEmailID,
        FarmerName,
        ProductID,
        ProductCategoryID,
        PricePerMT,
        TotalPrice,
        APType,
        APName,
        Country,
        ...updatedSelectedAgropreneurItemDetail
      } = selectedAgropreneurItemDetail;
      console.log(
        "updatedSelectedAgropreneurItemDetail@@",
        updatedSelectedAgropreneurItemDetail
      );

      const body = {
        target: isAdding ? "addAPItem" : "saveAPItem",
        access_token: user.signInUserSession.idToken.jwtToken,
        APItemInput: {
          ProductID: products.find(
            (item) =>
              item.ProductName ===
                updatedSelectedAgropreneurItemDetail.ProductName &&
              item.Grade === updatedSelectedAgropreneurItemDetail.Grade
          ).ProductID,
          ...updatedSelectedAgropreneurItemDetail,
        },
      };

      const params = {
        FunctionName: `backendops-${getBackendName()}`, // Updated to backendops
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        setShowModalMsg(`${status} action successful`);
        setShowModal(true);
        fetchAgropreneurItems();
        setIsAdding(false);
      } else {
        console.error(`Error updating APItem: `, result);
        setShowModalMsg(`Error updating APItem: ${result.error}`);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
      setShowModalMsg("Error invoking Lambda function: ", error);
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setIsAdding(true);
    setProducts([]);
    setSelectedAgropreneurItemDetail({
      FarmerEmailID: "",
      ProductCategoryID: "",
      ProductName: "",
      Grade: "",
      Quantity: 0,
      Price: 0,
      State: "",
      Expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
        .toISOString()
        .split("T")[0],
      productSpecifications: "",
      Currency: "INR",
      Payment: "",
    });
  };

  const resetFilter = () => {
    setSelectedAgropreneurItemDetail(null);
    setCurrentPage(1);
    setSelectedQuery(null);
    setQueryPage(1);
    setQueries([]);
  };

  function isValidNumber(value) {
    return value !== "" && !isNaN(value);
  }

  const handleDateChange = (date, field) => {
    setSelectedAgropreneurItemDetail({
      ...selectedAgropreneurItemDetail,
      [field]: date ? date.toISOString().split("T")[0] : "",
    });
  };

  const handleAgropreneurItemDetailChange = (event) => {
    const { id, value } = event.target;
    console.log("handleAgropreneurItemDetailChange e#", id, value);
    const floatFields = ["Quantity", "Price"];
    const intFields = [];
    let newAgropreneurItemDetail = {
      ...selectedAgropreneurItemDetail,
    };
    if (id === "ProductCategoryID") {
      loadProducts(event.target.value);
    }
    if (floatFields.includes(id)) {
      if (isValidNumber(value)) {
        newAgropreneurItemDetail[id] = parseFloat(value);
      } else {
        newAgropreneurItemDetail[id] = 0;
      }
    } else if (intFields.includes(id)) {
      if (isValidNumber(value)) {
        newAgropreneurItemDetail[id] = parseInt(value);
      } else {
        newAgropreneurItemDetail[id] = 0;
      }
    } else {
      newAgropreneurItemDetail[id] = value;
    }
    setSelectedAgropreneurItemDetail(newAgropreneurItemDetail);
  };

  return (
    <div className="agropreneur-dashboard">
      <header>
        <img src="/images/logo.png" alt="Grains Global Logo" className="logo" />
        <nav>
          <ul>
            <li>
              <a href="/agropreneur">Dashboard</a>
            </li>
            <li>
              <a href="/my-farmers">My Farmers</a>
            </li>
            <li>{activeUser}</li>
            <li>
              <button onClick={handleSignOut} className="sign-out-button">
                Sign Out
              </button>
            </li>
          </ul>
        </nav>
      </header>

      <div className="content">
        <main className="main-content">
          <div className="offers-search row">
            <div className="col-lg-2 col-sm-3 col-6">
              <select
                className="form-control form-select"
                id="farmer"
                name="farmer"
                value={filterTerms.farmer || ""}
                onChange={handleFilterChange}
              >
                <option value="">Select Farmer</option>
                {[...new Set(farmers)].map((farmer) => {
                  const match = farmer.match(/<([^>]+)>/); // Regex to extract content within <>
                  const keyAndValue = match ? match[1] : ""; // Extract content if present
                  return (
                    <option key={keyAndValue} value={keyAndValue}>
                      {farmer}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-lg-2 col-sm-3 col-6">
              <select
                className="form-control form-select"
                id="productcategory"
                name="productcategory"
                value={filterTerms.productcategory || ""}
                onChange={handleCategoryChange}
              >
                <option value="">Select a product category</option>
                {productCategoryMaster.map((p) => (
                  <option key={p.ProductCategoryID} value={p.ProductCategoryID}>
                    {p.CategoryName}
                  </option>
                ))}
                {/* {[
                  ...new Set(productCategoryMaster.map((product) => product.ProductCategoryID)),
                ].map((product) => (
                  <option key={product.ProductCategoryID} value={product.ProductCategoryID}>
                    {product.CategoryName}
                  </option>
                ))} */}
              </select>
            </div>
            <div className="col-lg-2 col-sm-3 col-6">
              <select
                className="form-control form-select"
                id="product"
                name="product"
                value={filterTerms.product || ""}
                onChange={handleFilterChange}
              >
                <option value="">Select a product</option>
                {[
                  ...new Set(products.map((product) => product.ProductName)),
                ].map((product) => (
                  <option key={product} value={product}>
                    {product}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-2 col-sm-3 col-6">
              <select
                className="form-control form-select"
                id="grade"
                name="grade"
                value={filterTerms.grade || ""}
                onChange={handleFilterChange}
              >
                <option value="">Select a Grade</option>
                {products
                  .filter(
                    (product) => product.ProductName === filterTerms.product
                  )
                  .map((product) => (
                    <option key={product.Grade} value={product.Grade}>
                      {product.Grade}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-lg-2 col-sm-3 col-6">
              <select
                className="form-control form-select"
                id="state"
                name="state"
                value={filterTerms.state || ""}
                onChange={handleFilterChange}
              >
                <option value="">Select State</option>
                {states.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-2 col-sm-3 col-6">
              <button onClick={handleSearch} className="mx-3 d-inline">
                Search
              </button>
              <button onClick={handleReset} className="d-inline">
                Reset
              </button>
            </div>
          </div>
          <section className="offers">
            <table>
              <thead>
                <tr>
                  <th>Farmer</th>
                  <th>Product</th>
                  <th>Grade</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>State</th>
                  <th>Expires</th>
                  <th>Offer Created</th>
                </tr>
              </thead>
              <tbody>
                {agropreneurItemDetails.map((agropreneurItemDetail) => (
                  <tr
                    key={agropreneurItemDetail.APItemID}
                    onClick={() => handleRowClick(agropreneurItemDetail)}
                    className={
                      selectedAgropreneurItemDetail &&
                      selectedAgropreneurItemDetail?.APItemID ===
                        agropreneurItemDetail.APItemID
                        ? "selected"
                        : ""
                    }
                  >
                    <td>
                      {agropreneurItemDetail.FarmerName} &lt;
                      {agropreneurItemDetail.FarmerEmailID}&gt;
                    </td>
                    <td>{agropreneurItemDetail.ProductName}</td>
                    <td>{agropreneurItemDetail.Grade}</td>
                    <td>{agropreneurItemDetail.Quantity}</td>
                    <td>{agropreneurItemDetail.Price}</td>
                    <td>{agropreneurItemDetail.State}</td>
                    <td>{agropreneurItemDetail.Expires}</td>
                    <td>
                      {agropreneurItemDetail.SellerItemID === null ||
                      agropreneurItemDetail.SellerItemID === undefined
                        ? "No"
                        : "Yes"}
                    </td>
                  </tr>
                ))}
                {agropreneurItemDetails.length === 0 && (
                  <tr>
                    <td colSpan="7">No Agropreneur items available</td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="pagination">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {"<"}
              </button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={currentPage === index + 1 ? "active" : ""}
                >
                  {index + 1}
                </button>
              ))}
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                {">"}
              </button>
            </div>
          </section>

          <section className="product-details">
            <div className="tabs">
              <button
                className={activeTab === "basicInfo" ? "active" : ""}
                onClick={() => handleTabClick("basicInfo")}
              >
                Basic Info
              </button>
              <button
                className={activeTab === "specifications" ? "active" : ""}
                onClick={() => handleTabClick("specifications")}
              >
                Specifications
              </button>
              <button
                className={activeTab === "pricing" ? "active" : ""}
                onClick={() => handleTabClick("pricing")}
              >
                Pricing
              </button>
              <button
                className={activeTab === "queries" ? "active" : ""}
                onClick={() => handleTabClick("queries")}
              >
                Queries
              </button>
            </div>

            {activeTab === "basicInfo" && (
              <div className="tab-content active">
                <div className="row">
                  <div className="col-lg-9 col-sm-9 col-6">
                    <div className="row">
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Farmer</label>
                        <select
                          className="form-control form-select"
                          id="FarmerEmailID"
                          value={selectedAgropreneurItemDetail?.FarmerEmailID}
                          onChange={handleAgropreneurItemDetailChange}
                        >
                          <option value="">Select Farmer</option>
                          {[...new Set(allFarmers)].map((farmer) => {
                            const match = farmer.match(/<([^>]+)>/); // Regex to extract content within <>
                            const keyAndValue = match ? match[1] : ""; // Extract content if present
                            return (
                              <option key={keyAndValue} value={keyAndValue}>
                                {farmer}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Product Category</label>
                        <select
                          className="form-control form-select"
                          id="ProductCategoryID"
                          value={
                            selectedAgropreneurItemDetail?.ProductCategoryID ||
                            ""
                          }
                          onChange={handleAgropreneurItemDetailChange}
                        >
                          <option value="">Select a product category</option>
                          {productCategoryMaster.map((pc) => (
                            <option
                              key={pc.ProductCategoryID}
                              value={pc.ProductCategoryID}
                            >
                              {pc.CategoryName}
                            </option>
                          ))}
                          {/* {[
                            ...new Set(
                              productCategoryMaster.map((pc) => pc.ProductName)
                            ),
                          ].map((pc) => (
                            <option key={pc.ProductCategoryID} value={pc.ProductCategoryID}>
                              {pc.CategoryName}
                            </option>
                          ))} */}
                        </select>
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Product</label>
                        <select
                          className="form-control form-select"
                          id="ProductName"
                          value={
                            selectedAgropreneurItemDetail?.ProductName || ""
                          }
                          onChange={handleAgropreneurItemDetailChange}
                        >
                          <option value="">Select a product</option>
                          {[
                            ...new Set(
                              products.map((product) => product.ProductName)
                            ),
                          ].map((product) => (
                            <option key={product} value={product}>
                              {product}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Grade</label>
                        <select
                          className="form-control form-select"
                          id="Grade"
                          value={selectedAgropreneurItemDetail?.Grade || ""}
                          onChange={handleAgropreneurItemDetailChange}
                        >
                          <option value="">Select a Grade</option>
                          {products
                            .filter(
                              (product) =>
                                product.ProductName ===
                                selectedAgropreneurItemDetail?.ProductName
                            )
                            .map((product) => (
                              <option key={product.Grade} value={product.Grade}>
                                {product.Grade}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Quantity</label>
                        <input
                          id="Quantity"
                          type="text"
                          value={selectedAgropreneurItemDetail?.Quantity}
                          className="form-control"
                          onChange={handleAgropreneurItemDetailChange}
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Price</label>
                        <input
                          id="Price"
                          type="text"
                          value={selectedAgropreneurItemDetail?.Price}
                          className="form-control"
                          onChange={handleAgropreneurItemDetailChange}
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>State</label>
                        <select
                          className="form-control form-select"
                          id="State"
                          value={selectedAgropreneurItemDetail?.State}
                          onChange={handleAgropreneurItemDetailChange}
                        >
                          <option value="">Select State</option>
                          {allStates.map((state) => (
                            <option key={state.Value} value={state.Value}>
                              {state.Value}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Expires</label>
                        <DatePicker
                          id="Expires"
                          selected={
                            selectedAgropreneurItemDetail?.Expires
                              ? new Date(selectedAgropreneurItemDetail.Expires)
                              : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
                          }
                          onChange={(date) => handleDateChange(date, "Expires")}
                          dateFormat="yyyy-MM-dd"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-6">
                    <div className="actions">
                      <div className="row">
                        <div className="col-12 mb-2">
                          <button disabled={isAdding} onClick={handleAdd}>
                            Add
                          </button>
                        </div>
                        <div className="col-12 mb-2">
                          <button onClick={handleSave}>Save</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "specifications" && (
              <div className="tab-content active">
                <div className="row">
                  <div className="col-lg-9 col-sm-9 col-6">
                    <div className="row">
                      <div className="col-lg-9 col-sm-9 col-6">
                        <div className="row">
                          <label htmlFor="productSpecifications">
                            Product Specifications
                          </label>
                          <textarea
                            id="productSpecifications"
                            name="productSpecifications"
                            className="form-control"
                            rows="10"
                            value={
                              selectedAgropreneurItemDetail.productSpecifications ||
                              ""
                            }
                            onChange={handleAgropreneurItemDetailChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-6">
                    <div className="actions">
                      <div className="row">
                        <div className="col-12 mb-2">
                          <button disabled={isAdding} onClick={handleAdd}>
                            Add
                          </button>
                        </div>
                        <div className="col-12 mb-2">
                          <button onClick={handleSave}>Save</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "pricing" && (
              <div className="tab-content active">
                <div className="row">
                  <div className="col-lg-9 col-sm-9 col-6">
                    <div className="row">
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Currency</label>
                        <input
                          id="Currency"
                          type="text"
                          readOnly
                          value={selectedAgropreneurItemDetail?.Currency}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Price / MT</label>
                        <input
                          id="Price"
                          type="text"
                          value={selectedAgropreneurItemDetail?.Price}
                          className="form-control"
                          onChange={handleAgropreneurItemDetailChange}
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Total Price</label>
                        <input
                          type="text"
                          readOnly
                          value={formatData(
                            selectedAgropreneurItemDetail?.Quantity *
                              selectedAgropreneurItemDetail?.Price
                          )}
                          className="form-control"
                        />
                      </div>
                      <div className="col-lg-3 col-sm-4 col-6">
                        <label>Payment</label>
                        <select
                          className="form-control form-select"
                          id="Payment"
                          value={selectedAgropreneurItemDetail?.Payment}
                          onChange={handleAgropreneurItemDetailChange}
                        >
                          <option value="">Select Payment</option>
                          {paymentOptions.map((paymentOption) => (
                            <option
                              key={paymentOption.Value}
                              value={paymentOption.Value}
                            >
                              {paymentOption.Value}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-6">
                    <div className="actions">
                      <div className="row">
                        <div className="col-12 mb-2">
                          <button disabled={isAdding} onClick={handleAdd}>
                            Add
                          </button>
                        </div>
                        <div className="col-12 mb-2">
                          <button onClick={handleSave}>Save</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "queries" && (
              <div className="tab-content active">
                <div className="row">
                  <div className="col-lg-10 col-sm-9 col-12">
                    <table>
                      <thead>
                        <tr>
                          <th>Query Date</th>
                          <th>Query</th>
                          <th>Reply Date</th>
                          <th>Reply</th>
                        </tr>
                      </thead>
                      <tbody>
                        {queries.map((query) => (
                          <tr
                            key={query.QueryID}
                            onClick={() => handleQueryRowClick(query)}
                            className={
                              selectedQuery &&
                              selectedQuery.QueryID === query.QueryID
                                ? "selected"
                                : ""
                            }
                          >
                            <td>{query.QueryDate}</td>
                            <td>{query.QueryDescription}</td>
                            <td>{query.QueryReplyDate}</td>
                            <td>{query.QueryReply}</td>
                          </tr>
                        ))}
                        {queries.length === 0 && (
                          <tr>
                            <td colSpan="4">No queries available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-lg-2 col-sm-3 col-12">
                    <div className="actions">
                      <button
                        disabled={
                          selectedAgropreneurItemDetail === undefined ||
                          selectedAgropreneurItemDetail === null
                        }
                        onClick={() => {
                          setShowRaiseQueryModal(true);
                        }}
                      >
                        Raise Query
                      </button>
                    </div>
                  </div>
                </div>
                <div className="pagination">
                  <button
                    onClick={() => handleQueryPageChange(queryPage - 1)}
                    disabled={queryPage === 1}
                  >
                    {"<"}
                  </button>
                  {Array.from({ length: queryTotalPages }, (_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => handleQueryPageChange(index + 1)}
                      className={queryPage === index + 1 ? "active" : ""}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => handleQueryPageChange(queryPage + 1)}
                    disabled={queryPage === queryTotalPages}
                  >
                    {">"}
                  </button>
                </div>
              </div>
            )}
          </section>
        </main>

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>{showModalMsg}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showRaiseQueryModal}
          onHide={() => setShowRaiseQueryModal(false)}
          backdrop="static"
          className="modal-raisequery"
        >
          <Modal.Header closeButton>
            <Modal.Title>Raise Query</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                <textarea
                  placeholder="Enter Query Description"
                  className="form-control mb-2"
                  value={queryDescription}
                  onChange={(e) => setQueryDescription(e.target.value)}
                ></textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleCreateQuery}>
              Raise Query
            </Button>
            <Button
              variant="secondary"
              onClick={() => setShowRaiseQueryModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default AgroPreneurDashboard;
